module.exports = __webpack_public_path__ + "img/img_manual2_1.54d54861.jpg";